import { render, staticRenderFns } from "./DetailClassroom.vue?vue&type=template&id=cf8f9b1c"
import script from "./DetailClassroom.vue?vue&type=script&lang=js"
export * from "./DetailClassroom.vue?vue&type=script&lang=js"
import style0 from "./DetailClassroom.vue?vue&type=style&index=0&id=cf8f9b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports